module.exports = __webpack_public_path__ + "img/box1.7f3d6f35.png";